// empty declaration to avoid errors. This will be overwritten below
let addToBundle = () => { };

document.addEventListener('BundleTilesLoaded', () => {
  const BUNDLE_STORAGE_KEY = 'bundleItems';

  const DOM = {
    container: 'bundle-items-container',
    selectBtn: 'select-items-btn',
    checkoutBtn: 'bundle-checkout-btn',
    clearAll: '.clear-all',
    clear: '.clear',
    subtotalDisplay: '.subtotal-display',
    subtotal: '.subtotal-amount',
    subtotalCompareAt: '.subtotal-amount-compare-at',
    subtotalSavings: '.subtotal-savings',
    cartLinePrice: '.line-item-price',
    cartPrice: '.cart-script-price',
    cartCompareAt: '.cart-script-compare-at',
    mobileExpand: '.mobile-expand',
    bundleItemsEl: '.bundle-items',
    progressBarEl: '.progress-bar-widget-new',
    progressBarWidget: '.progress-bar-widget-info',
  };

  const container = document.getElementById(DOM.container);
  const selectBtn = document.getElementById(DOM.selectBtn);
  const checkoutBtn = document.getElementById(DOM.checkoutBtn);
  const clearAll = document.querySelector(DOM.clearAll);
  const clear = document.querySelector(DOM.clear);
  const subtotalDisplayEl = document.querySelector(DOM.subtotalDisplay);
  const subtotalEl = document.querySelector(DOM.subtotal);
  const subtotalCompareAt = document.querySelector(DOM.subtotalCompareAt);
  const subtotalSavings = document.querySelector(DOM.subtotalSavings);

  const mobileExpand = document.querySelector(DOM.mobileExpand);
  const bundleItemsEl = document.querySelector(DOM.bundleItemsEl);
  const progressBarEl = document.querySelector(DOM.progressBarEl);
  let progressBarWidget = document.querySelector(DOM.progressBarWidget);

  const $progressBar = $('.progress-bar-widget-new__progress-bar');
  const thresholdsEl = $('#bundle-progress-data');
  const threshold1 = parseInt(thresholdsEl.data('threshold-1'), 10);
  const threshold1Discount = parseInt(thresholdsEl.data('threshold-1-discount'), 10);
  const threshold2 = parseInt(thresholdsEl.data('threshold-2'), 10);
  const threshold2Discount = parseInt(thresholdsEl.data('threshold-2-discount'), 10);
  const threshold3 = parseInt(thresholdsEl.data('threshold-3'), 10);
  const threshold3Discount = parseInt(thresholdsEl.data('threshold-3-discount'), 10);

  const isMobile = window.innerWidth <= 750;

  let progress = 0;
  let thresholdDiscount = 0;

  function getBundleItems() {
    const data = localStorage.getItem(BUNDLE_STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  }

  function saveBundleItems(items) {
    localStorage.setItem(BUNDLE_STORAGE_KEY, JSON.stringify(items));
    // remove all quantities first
    const allProductTiles = document.querySelectorAll(`[data-product-handle]`);
    allProductTiles.forEach((qtyCount) => {
      qtyCount.querySelector('span').innerText = '';
      qtyCount.style.display = 'none';
    });
    if (items.length === 0) {
      container.classList.remove('has-items');
      return;
    }
    items.forEach((item) => {
      const qtyCount = document.querySelector(`[data-product-handle^="${item.handle}"]`);
      if (qtyCount) {
        const { handle } = item;
        const foundItems = items.filter((item) => item.handle === handle);
        const count = foundItems.length;
        qtyCount.querySelector('span').innerText = count;
        qtyCount.style.display = 'flex';
      }
    });
    if (items.length === 0) {
      document.querySelectorAll(`[data-product-handle]`).forEach((qtyCount) => {
        qtyCount.style.display = 'none';
      });
    }
  }

  function updateProgressBarWidget() {
    const items = getBundleItems();
    const count = items.reduce((sum, item) => sum + (item.quantity || 1), 0);

    if (count <= threshold1) {
      // 0 to threshold1 = 0% to 33%
      progress = (count / threshold1) * 33;
      if (count >= threshold1) {
        thresholdDiscount = threshold1Discount;
      }
    } else if (count <= threshold2) {
      // threshold1 to threshold2 = 33% to 66%
      const extra = count - threshold1;
      const range = threshold2 - threshold1;
      progress = 33 + (extra / range) * 33;
      thresholdDiscount = threshold1Discount;
      if (count >= threshold2) {
        thresholdDiscount = threshold2Discount;
      }
    } else if (count <= threshold3) {
      // threshold2 to threshold3 = 66% to 100%
      const extra = count - threshold2;
      const range = threshold3 - threshold2;
      progress = 66 + (extra / range) * 34;
      thresholdDiscount = threshold2Discount;
      if (count >= threshold3) {
        thresholdDiscount = threshold3Discount;
      }
    } else {
      // More than threshold3
      progress = 100;
      thresholdDiscount = threshold3Discount;
    }

    $progressBar.css('width', `${progress}%`);
  }

  addToBundle = (item) => {
    const currentItems = getBundleItems();
    currentItems.push(item);

    saveBundleItems(currentItems);
    updateDOM();
    updateProgressBarWidget();
    renderBundleItems();
    updatePrices();
  };

  function renderBundleItems() {
    const items = getBundleItems();
    if (!container) return;
    if (items.length === 0) {
      container.innerHTML = '';
      return;
    }
    container.innerHTML = ''; // Clear previous content
    const addItemToDom = (item) => {
      const itemHtml = `
        <div class="line-item" data-line-item-id="${item.id}" data-line-item-title="${item.title}">
        <div class="line-item-image">
        <img loading="lazy" src="${item.imageUrl}" alt="${item.title}">
        </div>
        <div class="line-item-information">
        <div class="line-item-title">${item.title}</div>
        <div class="line-item-options">
        <p><span>${item.variantTitle || ''}</span></p>
        </div>
        <div class="line-item-amounts">

        <div class="line-item-price">
        <span class="cart-price cart-script-price">${item.price || 0}</span>
        <span class="cart-script-compare-at hidden">${item.price || 0}</span>
        </div>
        </div>

        </div>
        <span class="delete-line-item" data-bundle-remove-item="${item.id}" data-variant-id="${
        item.variantId || ''
        }" data-unique-id="${item.uniqueId || ''}">
        &times;
        </span>
        </div>
        `;
      container.insertAdjacentHTML('beforeend', itemHtml);
    };

    items.forEach((item) => {
      if (item.quantity) {
        for (let i = 0; i < item.quantity; i++) {
          addItemToDom(item);
        }
      } else {
        addItemToDom(item);
      }
    });

    const containerItem = document.getElementById(DOM.container);
    if (containerItem.innerHTML.trim() !== '') {
      // add .has-items class
      containerItem.classList.add('has-items');
      progressBarWidget.classList.remove('hidden');
    } else {
      containerItem.classList.remove('has-items');
      progressBarWidget.classList.add('hidden');
    }
  }

  function updateDOM() {
    const bundle = JSON.parse(localStorage.getItem('bundleItems')) || [];

    if (bundle.length > 0) {
      selectBtn.disabled = false;
      selectBtn.classList.remove('btn-disabled');
      selectBtn.classList.add('hidden');
      checkoutBtn.classList.remove('hidden');
      clearAll.classList.remove('hidden');
      subtotalDisplayEl.classList.remove('hidden');
      progressBarWidget.classList.remove('hidden');
    } else {
      selectBtn.disabled = true;
      selectBtn.classList.add('btn-disabled');
      selectBtn.classList.remove('hidden');
      checkoutBtn.classList.add('hidden');
      clearAll.classList.add('hidden');
      subtotalDisplayEl.classList.add('hidden');
      progressBarWidget.classList.add('hidden');
    }
  }

  function updatePrices() {
    // Update subtotals
    const items = getBundleItems();
    if (items.length === 0) return;
    document.querySelectorAll('.line-item').forEach((el) => {
      el.classList.add('selected');
    });

    // update subtotal amounts
    const price = items.reduce((sum, item) => {
      const price = parseFloat(item.price.toString().replace('$', '')) || 0;
      return sum + price;
    }, 0);
    subtotalEl.textContent = `$${price.toFixed(2)}`;

    const count = items.reduce((sum, item) => sum + (item.quantity || 1), 0);
    if (items && count >= threshold1) {
      const discountedPrice = items.reduce((sum, item) => {
        const price = parseFloat(item.price.toString().replace('$', '')) || 0;
        const discountedPrice = price - price * (thresholdDiscount / 100);
        return sum + discountedPrice;
      }, 0);

      subtotalEl.textContent = `$${discountedPrice.toFixed(2)}`;
      subtotalCompareAt.innerHTML = `$${price.toFixed(2)}`;
      subtotalSavings.innerHTML = `Save ${thresholdDiscount}%`;
      subtotalEl.classList.add('discounted');
      subtotalCompareAt.classList.remove('hidden');
      subtotalSavings.classList.remove('hidden');
    } else {
      subtotalEl.classList.remove('discounted');
      subtotalCompareAt.classList.add('hidden');
      subtotalSavings.classList.add('hidden');
    }

    // Update line item prices
    const linePriceContainer = document.querySelectorAll(DOM.cartLinePrice);
    linePriceContainer.forEach((priceEl) => {
      const cartPriceEl = priceEl.querySelector(DOM.cartPrice);
      const cartCompareAtEl = priceEl.querySelector(DOM.cartCompareAt);

      if (items && count >= threshold1) {
        const itemId = priceEl.closest('.line-item').getAttribute('data-line-item-id');
        const item = items.find((i) => i.id.toString() === itemId.toString());
        if (item) {
          const originalPrice = parseFloat(item.price.toString().replace('$', '')) || 0;
          const discountedPrice = originalPrice - originalPrice * (thresholdDiscount / 100);
          cartPriceEl.textContent = `$${discountedPrice.toFixed(2)}`;
          cartCompareAtEl.textContent = `$${originalPrice.toFixed(2)}`;
          cartPriceEl.classList.add('discounted');
          cartCompareAtEl.classList.remove('hidden');
        }
      } else {
        cartPriceEl.classList.remove('discounted');
        cartCompareAtEl.classList.add('hidden');
      }
    });
  }

  function removeFromBundle(itemId, uniqueId) {
    const items = getBundleItems();
    let filteredItems = items.map((item) => {
      const matchingItem = item.id.toString() === itemId.toString() && item.uniqueId === uniqueId ? item : false;
      if (!matchingItem) return item;
      if (matchingItem.quantity > 1) {
        matchingItem.quantity -= 1;
      } else {
        return null;
      }
      return matchingItem;
    });
    filteredItems = filteredItems.length ? filteredItems.filter((item) => item !== null) : [];
    saveBundleItems(filteredItems);
    updateProgressBarWidget();
    updateDOM();
    renderBundleItems();
    updatePrices();
  }

  document.addEventListener('click', function (event) {
    const target = event.target;
    if (target.classList.contains('delete-line-item')) {
      const itemId = target.getAttribute('data-bundle-remove-item');
      // const itemVariantId = target.getAttribute('data-variant-id');
      const itemUniqueId = target.getAttribute('data-unique-id');
      if (itemId) {
        removeFromBundle(itemId, itemUniqueId);
      }
    }
  });

  function refreshPage(clearItems = false) {
    if (clearItems) {
      localStorage.removeItem(BUNDLE_STORAGE_KEY);
    }
    updateDOM();
    renderBundleItems();
    updateProgressBarWidget();
    updatePrices();
    saveBundleItems(getBundleItems());
  }

  refreshPage();

  // Events
  clear &&
  clear.addEventListener('click', () => {
    refreshPage(true);
    saveBundleItems([]);
  });

  // scroll event for progress bar widget -- desktop only
  progressBarWidget = document.querySelector('.bundle-progress-bar-widget-new__wrapper');
  const progressBarContainer = document.querySelector('.progress-bar-widget-container');
  if (progressBarContainer && !isMobile) {
    const stickyOffset = progressBarContainer.offsetTop;
    window.addEventListener('scroll', () => {
      if (window.pageYOffset + 80 > stickyOffset) {
        progressBarContainer.classList.add('scroll');
      } else {
        progressBarContainer.classList.remove('scroll');
      }
    });
  }

  // mobile the `container` right after mobile-expand element
  if (isMobile) {
    progressBarWidget.insertBefore(bundleItemsEl, progressBarEl);
    clearAll.classList.add('btn');
    clearAll.style.width = '100%';
  }

  mobileExpand &&
  mobileExpand.addEventListener('click', () => {
    const hasItems = getBundleItems().length > 0;
    if (mobileExpand.classList.contains('expanded')) {
      mobileExpand.classList.remove('expanded');
      bundleItemsEl.classList.remove('expanded');
      container.classList.remove('expanded');
      container.classList.add('hidden');
    } else if (!mobileExpand.classList.contains('expanded') && hasItems) {
      mobileExpand.classList.add('expanded');
      bundleItemsEl.classList.add('expanded');
      container.classList.add('expanded');
      container.classList.remove('hidden');
    }
  });

  checkoutBtn &&
  checkoutBtn.addEventListener('click', () => {
    const items = getBundleItems();

    items.forEach((item, index) => {
      const fetchUrl = `${window.location.origin}/products/${item.handle}?view=quickshop`;
      const timeout = index > 0 ? (index > 1 ? 2000 * index : 1000) : 0;
      // settimeout is necessary to allow time for each item and their samples to be added to cart without any issues
      setTimeout(() => {
        $.get(fetchUrl).done((result) => {
          // this is needed for the `addedToCart` method to function correctly
          $('[quickshop-content]').html(result);

          // Add to cart with it's samples
          $form = $('.js-product-form');
          $productGroups = $('.js-product-option-group');
          $productGroups.attr('data-variant', item.variantId);

          // set quantity
          $('.js-product-option-group').attr('data-bundle-qty', 1);
          productGroupsCount = $productGroups.length;
          $productFreeSamplesGroups = $('.js-product-freesamples-option-group');
          productFreeSamplesGroupsCount = $productFreeSamplesGroups.length;

          $.each($productFreeSamplesGroups, (index, sample) => {
            sample.dataset.variant = item.freeSamples[index];
          });

          window.QuickShop.addedToCart(
            $form,
            $productGroups,
            productGroupsCount,
            $productFreeSamplesGroups,
            productFreeSamplesGroupsCount
          );
        });
      }, timeout);
    });

    // allow time to add to cart
    setTimeout(() => {
      refreshPage(true);
      saveBundleItems([]);
    }, 1000);
    $('[quickshop-content]').empty();
  });
});
